export default {
  // list
  'base_warehouse.query.name': 'name',
  'base_warehouse.query.name.placeholder': 'Enter name',
  'base_warehouse.column.name': 'name',
  'base_warehouse.column.createBy': 'createBy',
  'base_warehouse.column.updateBy': 'updateBy',
  'base_warehouse.column.createTime': 'createTime',
  'base_warehouse.column.updateTime': 'updateTime',
  // edit
  'base_warehouse.edit.title': 'Edit BaseWarehouse',
  'base_warehouse.add.title': 'Add BaseWarehouse',
  'base_warehouse.edit.success': 'Edit Successful',
  'base_warehouse.add.success': 'Add Successful',
  'base_warehouse.form.name.required': 'name cannot be null',
  'base_warehouse.form.name': 'name',
  'base_warehouse.form.name.placeholder': 'Enter name',
}
